/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M33 44h84v11H33zM33 70h84v11H33zM33 96h84v11H33z"/></g>'
  }
})
